/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JsonMatrixResponse } from '../../models/json-matrix-response';
import { MatrixRequest } from '../../models/matrix-request';

export interface GetDefaultUsingPost$JsonCharsetUtf8$Params {

/**
 * Specifies the matrix profile.
 */
  profile: 'driving-car' | 'driving-hgv' | 'cycling-regular' | 'cycling-road' | 'cycling-mountain' | 'cycling-electric' | 'foot-walking' | 'foot-hiking' | 'wheelchair';
  
    /**
     * The request payload
     */
    body: MatrixRequest
}

export function getDefaultUsingPost$JsonCharsetUtf8(http: HttpClient, rootUrl: string, params: GetDefaultUsingPost$JsonCharsetUtf8$Params, context?: HttpContext): Observable<StrictHttpResponse<JsonMatrixResponse>> {
  const rb = new RequestBuilder(rootUrl, getDefaultUsingPost$JsonCharsetUtf8.PATH, 'post');
  if (params) {
    rb.path('profile', params.profile, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;charset=UTF-8', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JsonMatrixResponse>;
    })
  );
}

getDefaultUsingPost$JsonCharsetUtf8.PATH = '/v2/matrix/{profile}';
